import SessionEventProto from "../session-event-proto"

type TaskMessage = {
    id      :ID,
    taskId  :ID
}

type Header = {
    taskMessage : TaskMessage,
    isBulkUpdate: boolean
}

export default class SessionTaskMessageEvent extends SessionEventProto {

    private header  : Header

    constructor(sessionEvent:any) {
        super(sessionEvent)
        this.header     = {
            taskMessage : sessionEvent.taskMessage,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
    }

    process() {
        if (this.isDifferentCompany()) return false;

        gd.modelBus.newUpdate('task-message', this.method, this.header.taskMessage.taskId, this.data, this.header);
    }
};
